// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks-module--social-links--14hpK"};